import { render } from "./delivery_process_component.vue?vue&type=template&id=46173162&scoped=true"
import script from "./delivery_process_component.vue?vue&type=script&lang=js"
export * from "./delivery_process_component.vue?vue&type=script&lang=js"

import "./delivery_process_component.vue?vue&type=style&index=0&id=46173162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46173162"]])

export default __exports__